import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  handleSelectedProperties,
  gridForComputedIndex,
  gridForHazard,
  defaultMarks,
} from "./AniaDetailsUtils";

export const AniaNaturalCatastropheDetails = ({ selectedProperties: selectedProp }) => {
  const { t } = useTranslation();
  const [selectedProperties, setSelectedProperties] = useState(selectedProp);
  const [aniaRiskSliderMarks, setAniaRiskSliderMarks] = useState(defaultMarks);
  const [riskScore, setRiskScoreValue] = useState(0);
  useEffect(() => {
    handleSelectedProperties(
      "ANIA_RINDX_ITA_NCAT",
      selectedProp,
      setRiskScoreValue,
      setAniaRiskSliderMarks,
      setSelectedProperties,
    );
  }, [selectedProp]);

  const allocation = 0.25; // not calculated yet
  return (
    <Box m={2} mb={5}>
      {gridForComputedIndex(
        t,
        selectedProperties,
        riskScore,
        aniaRiskSliderMarks,
        t("climateIndex.AniaNcat"),
      )}
      {gridForHazard(
        t,
        t("climateIndex.highWind"),
        selectedProperties?.CartaPericolositaDelVento,
        allocation,
      )}
      {gridForHazard(t, t("climateIndex.hail"), selectedProperties?.Grandine, allocation)}
      {gridForHazard(t, t("riskAssessment.precipitation"), selectedProperties?.Precipitazione_75, allocation)}
      {gridForHazard(t, t("riskAssessment.snow"), selectedProperties?.Precipitazione_nevosa_30, allocation)}
    </Box>
  );
};
